import NuContaPage from 'screens/Contract/NuConta/NuConta';

export default NuContaPage;
